/* eslint-disable no-console */
const showLogs = () => document.location.search.includes('_showWalletLogs');

export const ddcLog = (label, data) => {
	if (showLogs()) {
		const style = 'background: black; margin: 8px 0; padding: 5px; border-radius: 3px; border: 1px solid white; color: #ff6900;';
		const logText = `%cDDC:WALLET: -> ${label}`;
		
		if (data) {
			console.log(logText, style, data);
			return;
		}

		console.log(logText, style);
	}
}

export const markPerformance = (label) => {
	if (showLogs()) {
		window.performance.mark(label);
	}
}

export const measurePerformance = (label, start, end) => {
	if (showLogs() && !!window.performance.getEntriesByName(label).length) {
		const measurement = window.performance.measure(label, start, end);
		ddcLog(label, measurement.duration);
		window.performance.clearMarks(start);
		window.performance.clearMarks(end);
		window.performance.clearMeasures(label);
	}
}
